import rison from 'rison';

import { api } from './Api';
import { IWorkflowToSave } from '../models';

export const getReportWorkflows = (reportId: number | string) => {
  const requestParams = {
    filters: [
      {
        col: 'report_id',
        opr: 'eq',
        value: reportId,
      },
    ],
  };

    return api
      .get(`/workflow/?q=${rison.encode(requestParams)}`)
      .then((res: any) => res.data);
};

export const getWorkflows = (active: boolean | undefined) => {
  /*
   * Get all workflows per workspace
   */
  let requestParams = null;
  if (active !== undefined) {
    requestParams = {
      filters: [
        {
          col: 'active',
          opr: 'eq',
          value: active,
        },
      ],
    };
  }

  return api
    .get(`/workflow/${requestParams ? '?q=' + rison.encode(requestParams) : ''}`)
    .then(res => res.data);
};

export const getWorkflow = (workflowUid: string) => {
  return api.get(`/workflow/${workflowUid}`).then((res: any) => res.data);
};

export const saveWorkflow = (workflow: IWorkflowToSave) => {
  const payload = {
    ...workflow,
    recipients: JSON.stringify(workflow.recipients),
    profile: workflow.profile ? JSON.stringify(workflow.profile) : undefined,
  };

  return api.post(`/workflow/`, payload).then((res: any) => res.data);
};

export const updateWorkflow = (uid: string, workflow: IWorkflowToSave) => {
  let payload = {
    ...workflow,
  };

  if (payload.recipients) {
    payload['recipients'] = JSON.stringify(workflow.recipients);
  }
  if (payload.profile) {
    payload['profile'] = JSON.stringify(workflow.profile);
  }

  return api.put(`/workflow/${uid}`, payload).then((res: any) => res.data);
};

export const removeWorkflow = (uid: string) => {
  return api.delete(`/workflow/${uid}`).then((res: any) => res.data);
};

export const runWorkflow = (uid: string) => {
  return api.post(`/workflow/${uid}/run`).then((res: any) => res.data);
};
